<template>
  <div
    class="noContent-style"
    :style="extraStyle"
  >
    <div v-if="!needLogin || $store.state.userinfo.isLogin">
      <img
        src="@/assets/svg/default.svg"
        @click="linkTimeoutRefresh"
      />
      <h1>{{ text || '暂无数据' }}</h1>
    </div>
    <div v-else>
      <img src="@/assets/svg/default.svg">
      <h1>
        请
        <a
          @click="login"
          class="smart_fontcolor1"
        >
          登录
        </a>
        后查看
      </h1>
    </div>
  </div>
</template>

<script>
export default {
  name: 'c-no-data',
  props: {
    needLogin: {
      type: Boolean,
      default: false
    },
    extraStyle: {
      type: Object,
      default: () => ({})
    },
    text: {
      type: String,
      default: ''
    }
  },
  methods: {
    login() {
      // this.$cookie.set('sky-token', '')
      // this.$cookie.set('refreshToken', '')
      // this.$cookie.set('expires_in', 0)
      // 显示登录弹窗
      // this.$store.dispatch('setQuickLogin', true)
    },
    linkTimeoutRefresh() {
      if (this.text && this.text.indexOf('网络异常') > -1) {
        window.location.reload()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.noContent-style {
  width: 100%;
  text-align: center !important;
  padding-top: 50px;
  min-height: 450px;
  background: #fff;
  h1 {
    font-size: 16px;
    color: #86909c;
    line-height: 22px;
    margin-top: 8px;
    font-weight: normal;
  }
  img {
    display: block;
    margin: 0 auto;
    width: 160px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/htmlSplit/components/CNoData.vue